import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { FeatureReel } from "./FeatureReel";
import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { TitanPanel } from "@lib/titan2/dist/game/control/TitanPanel";
import { ArrayUtil } from "@lib/titan2/dist/util/collection/ArrayUtil";
import { FeatureGoldFishEvents } from "./FeatureGoldFish";
import { SoundEvent } from "../../../../../controller/event/GameEvent";
export class FeatureReels extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
    }
    create() {
        super.create();
        this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.background, this.portraitProperties.background);
        this.foreground = TitanSprite.createSprite(this, "foreground", this.landscapeProperties.foreground, this.portraitProperties.foreground);
        this.panel = TitanPanel.createPanel(this, "reelsPanel", this.landscapeProperties.panelProperties, this.portraitProperties?.panelProperties);
        this.reels = [];
        for (let i = 0; i < 5; i++) {
            const reel = new FeatureReel(this.factory, this.landscapeProperties.reelProperties, this.portraitProperties.reelProperties);
            reel.setReelIndex(i);
            this.reels.push(reel);
            this.panel.addToPanel(reel, false);
        }
        this.panel.arrange();
    }
    spin(reelResult, symbolPayout, lockedReels) {
        if (reelResult.length !== 5 || symbolPayout.length !== 5) {
            throw new Error("Invalid Reel Result");
        }
        const startRipple = 30;
        const reelsTime = 800;
        const endRipple = 100;
        // quickly work out the final spinIndex
        const lastSpunReel = ArrayUtil.removeMatchingElements([0, 1, 2, 3, 4], lockedReels).pop();
        let reelsSpun = 0;
        this.reels.forEach((reel, i) => {
            if (lockedReels.includes(i)) {
                return;
            }
            this.callAfter(startRipple * reelsSpun, () => reel.spin());
            this.callAfter(reelsTime + (endRipple * reelsSpun), () => this.endOfReelSpin(reelResult[i], symbolPayout[i], i, lastSpunReel));
            reelsSpun++;
        });
    }
    endOfReelSpin(reelResult, symbolPayout, reelIndex, lastReelIndex) {
        this.dispatchGame(SoundEvent.GOLDFISH_REEL_STOP);
        this.reels[reelIndex].stop(reelResult, symbolPayout);
        if (reelIndex === lastReelIndex) {
            this.dispatchGame(FeatureGoldFishEvents.SPIN_ANIMATION_COMPLETE);
        }
        this.dispatchGame(SoundEvent.CLICK);
        switch (reelResult) {
            case "BLANK":
                break;
            case "GOLD":
                this.dispatchGame(SoundEvent.GOLD_TALLY);
                break;
            case "BLUE":
                this.dispatchGame(SoundEvent.BLUE_TALLY);
                break;
            case "GREEN":
                this.dispatchGame(SoundEvent.GREEN_TALLY);
                break;
            case "RED":
                this.dispatchGame(SoundEvent.RED_TALLY);
                break;
            case "PURPLE":
                this.dispatchGame(SoundEvent.PURPLE_TALLY);
                break;
        }
    }
    revealPayouts(payouts) {
        this.reels.forEach((reel, i) => reel.revealPayout(payouts[i]));
    }
    applyPayoutMultiplier(reelIndex, unmultipiedPayout, multipliedPayout) {
        this.reels[reelIndex].applyPayoutMultiplier(unmultipiedPayout, multipliedPayout);
    }
    hidePayout(reelIndex) {
        this.reels[reelIndex].hidePayout();
    }
    hideReelSymbol(reelIndex) {
        this.reels[reelIndex].hideReelSymbol();
    }
    getReelCenterPosition(reelIndex) {
        return this.reels[reelIndex].getReelCenterPosition();
    }
    getGlobalReelPayoutPosition(reelIndex) {
        return this.reels[reelIndex].getGlobalPayoutPosition();
    }
    getReelPayoutTitanText(reelIndex) {
        return this.reels[reelIndex].getPayoutTitanText();
    }
    getReelSymbol(reelIndex) {
        return this.reels[reelIndex].getReelSymbol();
    }
    enableLocks(lockingReels) {
        lockingReels.forEach(reelIndex => this.reels[reelIndex].enableLock());
    }
    clearLocks() {
        this.reels.forEach(reel => reel.clearLock());
    }
    clear() {
        this.reels.forEach(reel => reel.clear());
    }
}
//# sourceMappingURL=FeatureReels.js.map